import type { AISearchSearchResult } from './types';

export const NOT_ENOUGH_OPTIONS_THRESHOLD = 2;
export const TOO_MANY_OPTIONS_THRESHOLD = 200;

/**
 * The advisory messages the AI search may show. Values match the
 * `resultsMessageStatus` property on the `AI Prompt Sent` BigQuery event.
 * `supplierSearch` is sourced from the `declineOutOfScope` tool (a non-venue
 * request never runs a search), so it's not produced by this count-based helper.
 */
export type AISearchMessageType =
  | 'zeroResults'
  | 'widenYourSearch'
  | 'narrowYourSearch'
  | 'supplierSearch';

export const classifyResultMessage = (search: AISearchSearchResult): AISearchMessageType | null => {
  const total = search.totalResults;
  if (total === 0) return 'zeroResults';
  if (total < NOT_ENOUGH_OPTIONS_THRESHOLD) return 'widenYourSearch';
  if (total > TOO_MANY_OPTIONS_THRESHOLD) return 'narrowYourSearch';
  return null;
};
